import { useAppState } from '@/components/AppLayout'
import { NearbyMap } from './NearbyMap'

export function NearMePage() {
  const { lang, t } = useAppState()

  return (
    <NearbyMap
      lang={lang}
      translations={{
        loading: t.loading,
        locationError: t.locationError,
        enableLocation: t.enableLocation,
        nearbyStops: t.nearbyStops,
        metersAway: t.metersAway,
        noStopsNearby: t.noStopsNearby
      }}
    />
  )
}